// Web polyfill for react-native-screens
// This provides web-compatible implementations of react-native-screens components
import * as React from 'react';
import { View } from 'react-native';

// Screen component - just renders children in a View
export const Screen = React.forwardRef(({ children, style, enabled, activityState, ...props }, ref) => {
  // Ignore enabled and activityState on web - they're React Native specific
  return React.createElement(View, { style, ref, ...props }, children);
});
Screen.displayName = 'Screen';

// ScreenContainer - container for Screen components
export const ScreenContainer = React.forwardRef(({ children, style, enabled, ...props }, ref) => {
  // Ignore enabled on web
  return React.createElement(View, { style: [{ flex: 1 }, style], ref, ...props }, children);
});
ScreenContainer.displayName = 'ScreenContainer';

// ScreenStack - stack of screens
export const ScreenStack = React.forwardRef(({ children, style, ...props }, ref) => {
  return React.createElement(View, { style: [{ flex: 1 }, style], ref, ...props }, children);
});
ScreenStack.displayName = 'ScreenStack';

// NativeScreen - native screen wrapper (fallback to View on web)
export const NativeScreen = React.forwardRef(({ children, style, ...props }, ref) => {
  return React.createElement(View, { style, ref, ...props }, children);
});
NativeScreen.displayName = 'NativeScreen';

// NativeScreenContainer
export const NativeScreenContainer = React.forwardRef(({ children, style, ...props }, ref) => {
  return React.createElement(View, { style: [{ flex: 1 }, style], ref, ...props }, children);
});
NativeScreenContainer.displayName = 'NativeScreenContainer';

// NativeScreenNavigationContainer
export const NativeScreenNavigationContainer = React.forwardRef(({ children, style, ...props }, ref) => {
  return React.createElement(View, { style: [{ flex: 1 }, style], ref, ...props }, children);
});
NativeScreenNavigationContainer.displayName = 'NativeScreenNavigationContainer';

// ScreenStackHeaderConfig - header configuration (no-op on web)
export const ScreenStackHeaderConfig = (props) => {
  return null;
};

// ScreenStackHeaderSubview
export const ScreenStackHeaderSubview = (props) => {
  return null;
};

// Enable screens - no-op on web
export const enableScreens = (enabled = true) => {
  // No-op on web
};

// Enable freeze - no-op on web
export const enableFreeze = (freeze = true) => {
  // No-op on web
};

// screensEnabled - always return true on web
export const screensEnabled = () => {
  return true;
};

// shouldUseActivityState - always return false on web
export const shouldUseActivityState = () => {
  return false;
};

// SearchBar - no-op on web
export const SearchBar = (props) => {
  return null;
};

// Default export - same as named exports
const reactNativeScreens = {
  Screen,
  ScreenContainer,
  ScreenStack,
  NativeScreen,
  NativeScreenContainer,
  NativeScreenNavigationContainer,
  ScreenStackHeaderConfig,
  ScreenStackHeaderSubview,
  enableScreens,
  enableFreeze,
  screensEnabled,
  shouldUseActivityState,
  SearchBar,
};

export default reactNativeScreens;

if (typeof globalThis !== 'undefined' && !globalThis.__RN_SCREENS_POLYFILL__) {
  globalThis.__RN_SCREENS_POLYFILL__ = reactNativeScreens;
}
